<template>
  <spinner v-if="isLoading" />

  <div v-else class="limiter">
    <div class="container-login100 validate-form">
      <v-form ref="form" class="login100-form" lazy-validation @submit="register">
        <h2 class="header">Sign Up</h2>
        <v-alert v-if="message" type="error">{{ message }}</v-alert>

        <v-text-field class v-model="name" color="#fc00ff" :rules="nameRules" label="Name" required></v-text-field>
        <v-text-field class v-model="email" color="#fc00ff" :rules="emailRules" label="Email" required></v-text-field>
        <v-text-field type="password" v-model="password" :rules="passwordRules" color="#fc00ff" label="Password" required></v-text-field>

        <div class="container-login100-form-btn p-t-25">
          <v-btn type="submit" class="login100-form-btn submit-button" :disabled="isSubmitDisabled" dark tile large block :class="{ disabled: isSubmitDisabled }">Submit</v-btn>
        </div>
        <!-- <v-btn v-google="googleClientId" class="google-signin-button"> Continue with Google</v-btn>
        <LoginWithFacebook /> -->
      </v-form>
      <div class="login-with-container">
        <v-btn v-google="googleClientId" class="google-signin-button">
          <GoogleIcon class="google-icon" />
          Continue with Google
        </v-btn>
        <!-- <LoginWithFacebook class="login-with-facebook" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Spinner from "./Spinner";
// import LoginWithFacebook from "./LoginWithFacebook";
import GoogleIcon from "../../icons/google-icon.svg";

export default {
  name: "Register",
  components: {
    Spinner,
    // LoginWithFacebook,
    GoogleIcon,
  },
  data() {
    return {
      googleClientId:
        "1079289101555-j98hc0qnrhm806eidiofl2bh1hodt7a9.apps.googleusercontent.com",
      name: "",
      email: "",
      password: "",
      errorState: null,
      isLoading: false,
      message: "",
    };
  },

  computed: {
    nameRules() {
      return [
        (v) => !!v || "Name is required",
        (v) =>
          (v && v.length >= 3) || "Name must contain at least 3 characters",
      ];
    },
    emailRules() {
      return [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ];
    },
    passwordRules() {
      return [
        (v) => !!v || "Password is required",
        (v) =>
          (v && v.length >= 5) || "Password must contain at least 5 characters",
      ];
    },
    isSubmitDisabled() {
      const isValidName = !!this.name && this.name.length >= 3;
      const isValidEmail = !!this.email && /.+@.+\..+/.test(this.email);
      const isValidPassword = !!this.password && this.password.length >= 5;
      return !isValidName || !isValidEmail || !isValidPassword;
    },
  },

  methods: {
    ...mapActions(["registerUser", "setLoadingFlag", "loginUser"]),
    async OnGoogleAuthSuccess(idToken) {
      try {
        this.isLoading = true;
        await this.loginUser({
          provider: "google",
          token: idToken,
        });
        this.$router.push({ path: "/howToSave" });
        this.isLoading = false;
      } catch {
        this.isLoading = false;
      }
    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
    async register() {
      try {
        this.isLoading = true;
        await this.registerUser({
          name: this.name,
          email: this.email,
          password: this.password,
        });
        this.$router.push({ path: "/howToSave" });
      } catch (err) {
        this.resetPassword();
        this.isLoading = false;
        this.errorState = false;
        this.message = err.response.data;
      }
    },
    resetPassword() {
      this.password = "";
    },
  },
  watch: {
    email() {
      if (this.errorState === false) {
        this.errorState = null;
      }
    },
  },
};
</script>

<style scoped>
.limiter {
  display: flex;
  justify-content: center;
}
.validate-form {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.submit-button {
  margin-bottom: 10%;
  margin-top: 10%;
}
.header {
  margin: 10%;
  display: flex;
  justify-content: center;
  font-size: 30px;
  font-weight: 500;
  font-family: graphik lcg, proxima-nova, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  line-height: 1.25;
}
.form {
  margin-top: 5px;
}
.error-message {
  text-align: center;
}
.disabled {
  cursor: default;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #272727 !important;
}
.login-with-container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.login-with-facebook {
  margin-top: 10px;
  flex: 1;
}
.google-icon {
  height: 20px;
  width: 20px;
  margin-right: 10;
  margin-right: 10px;
}
</style>
